import { Validators } from '@angular/forms';
import { MultipleContractTypeSelectorComponent } from '@ordersnproducts/modules/one-click-order/components/contract-invoice-select/contract-invoice-select.component';
import { PurchaseOrderComponent } from '@ordersnproducts/modules/one-click-order/components/purchase-order/purchase-order.component';
import { OneClickContractEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-contract.effects';
import { OneClickHolidaysEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-holidays.effects';
import { OneClickJobsiteSalesAreaFromOrderEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-jobsite-sales-area.effects-order';
import { OneClickSalesAreaErrorEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-sales-area-error.effects';
import { OneCLickAlternativeUnitsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-units.effects';
import { OneClickContractProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-contract.provider';
import { OneClickDeliveryDateProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-date.provider';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickMultipleOption } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-is-multiple-option.provider';
import { OneClickPreviewStandardLotLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-standard-lot-loading.provider';
import { OneClickPurchaseOrderProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-purchase-order.provider';
import { OneClickRequestedTimeProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-requested-time.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickSetTimepickerDateFromDatepickerCommand } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-set-time-from-date-picker.comand.service';
import { OneClickSetContractPaymentTerm } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-contract-paymentTerm.command.service';
import { OneClickSetContract } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-contract.command.service';
import { OneClickSetPurchaseOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-purchase-order.command';
import { OneClickSetQuantityOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-quantity.command.service';
import { OneClickSetRequestedDateTime } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-requested-date-time.command.service';
import { OneClickUpdateSalesArea } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-sales-area.command';
import { OneClickSetUnitOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-unit-command.service';
import { OneClickContractsBalanceLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-contract-balance.loader.service';
import { OneClickUnitsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-units.loader.service';
import { OneClickBuilderField } from '@ordersnproducts/modules/one-click-order/util/constants/builder-fields';
import { OneClickPurchaseOrderValidator } from '@ordersnproducts/modules/one-click-order/validators/one-click-purchase-order.validator';
import { MAX_LENGTH_PO } from '@ordersnproducts/modules/order-builder/modules/location/constants/purchase-order.constants';
import { defaultDateTranslationNames } from '@ordersnproducts/modules/order-builder/modules/specification/configs/defaultDateTranslationNames';
import { MINUTE_STEP_PL } from '@ordersnproducts/modules/order-builder/modules/specification/configs/pl/constants';
import { ContractBalanceEffects } from '@ordersnproducts/modules/order-builder/modules/specification/effects/specification-form-effects/contract-balance.effects';
import { DecimalProvider } from '@ordersnproducts/modules/order-builder/modules/specification/providers/decimal.provider';
import { TimepickerHourFormat } from '@ordersnproducts/modules/shared/components/cmx-timepicker/cmx-timepicker.component';
import { FormInputDateComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/form-input-date.component';
import { FieldDateInputConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/field-date-input.config';
import { WeekDay } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/week-day';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import { FormInputTimeComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-time/form-input-time.component';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FieldInputTimeConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-time-config.interface';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import {
  OneClickContractPaymentProvider,
  OneClickHasResultProvider,
  OneClickNoResultProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickPlantsProvider } from '../../../../providers/order/one-click-plants.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-5 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
    hidden: OneClickNoResultProvider,
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickContractPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-3 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Plant,
    text: OneClickPlantsProvider,
    label: 'views.one_click.plant',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagplant',
    dataTIdValue: 'cmx-createoneclickorder-lblvalplant',
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
    visible: OneClickMultipleOption.IsSingleOption,
  } as FieldConfig,
  {
    type: FormInputNumberComponent,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-3 retail-control'],
    name: OneClickPreviewField.Quantity,
    min: 1,
    value: 1,
    step: 1,
    max: 99999,
    decimals: DecimalProvider,
    validation: [Validators.required, Validators.min(1), Validators.max(99999)],
    onChange: [OneClickSetQuantityOrder],
    hidden: OneClickHasResultProvider,
  } as FieldInputNumberConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.unit',
    name: OneClickBuilderField.Unit,
    placeholder: '',
    containerClassNames: ['col-md-3 retail-control'],
    onChange: [OneClickSetUnitOrder],
    dynamicEffects: [OneCLickAlternativeUnitsEffects],
    optionsLoader: OneClickUnitsLoaderService,
    validation: [Validators.required],
    hidden: OneClickHasResultProvider,
  } as FieldSelectConfig,
  {
    type: PurchaseOrderComponent,
    name: OneClickPreviewField.PurchaseOrder,
    label: 'views.one_click.purchase_order',
    dynamicEffects: [OneClickJobsiteSalesAreaFromOrderEffects],
    onChange: [OneClickSetPurchaseOrder],
    hidden: OneClickHasResultProvider,
    placeholder: 'views.one_click.enter_purchase_order',
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
    validation: [Validators.maxLength(MAX_LENGTH_PO)],
    asyncValidators: [OneClickPurchaseOrderValidator.validator],
  } as FieldConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PurchaseOrder,
    hidden: OneClickNoResultProvider,
    text: OneClickPurchaseOrderProvider,
    label: 'views.one_click.purchase_order',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
  {
    type: FormInputDateComponent,
    name: OneClickPreviewField.DeliveryDate,
    label: 'views.one_click.delivery_date',
    placeholder: 'mm/dd/yyyy',
    translationNames: defaultDateTranslationNames,
    startWeekWith: WeekDay.MONDAY,
    dynamicEffects: [OneClickHolidaysEffects],
    forbiddenWeekDays: [WeekDay.SUNDAY],
    onChange: [OneClickSetRequestedDateTime, OneClickSetTimepickerDateFromDatepickerCommand],
    hidden: OneClickHasResultProvider,
    containerClassNames: ['col-md-3 text-capitalize retail-control'],
    validation: [Validators.required],
    hideOutsideDays: true,
  } as FieldDateInputConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryDate,
    hidden: OneClickNoResultProvider,
    text: OneClickDeliveryDateProvider,
    label: 'views.one_click.delivery_date',
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
  } as FieldLabelConfig,
  {
    type: FormInputTimeComponent,
    label: 'views.one_click.request_time',
    name: OneClickPreviewField.Time,
    containerClassNames: ['col-md-3 text-capitalize retail-control'],
    hourFormat: TimepickerHourFormat.format24,
    minuteStep: MINUTE_STEP_PL,
    dynamicEffects: [OneClickSalesAreaErrorEffects],
    onChange: [OneClickSetRequestedDateTime, OneClickUpdateSalesArea],
    validation: [Validators.required],
    dataTIdLabel: 'cmx-createoneclickorder-seltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-selvaltimewindow',
    hidden: OneClickHasResultProvider,
  } as FieldInputTimeConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Time,
    hidden: OneClickNoResultProvider,
    text: OneClickRequestedTimeProvider,
    label: 'views.one_click.request_time',
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-lblvaltimewindow',
  } as FieldLabelConfig,
  {
    type: MultipleContractTypeSelectorComponent,
    name: OneClickPreviewField.Contract,
    label: 'views.one_click.contract',
    placeholder: 'views.one_click.select.contract',
    optionsLoader: OneClickContractsBalanceLoaderService,
    loading: OneClickPreviewStandardLotLoadingProvider,
    hidden: OneClickHasResultProvider,
    onChange: [OneClickSetContract, OneClickSetContractPaymentTerm],
    dynamicEffects: [OneClickContractEffects, ContractBalanceEffects],
    containerClassNames: ['col-md-12 text-capitalize retail-control'],
    validation: [],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Contract,
    hidden: OneClickNoResultProvider,
    text: OneClickContractProvider,
    label: 'views.one_click.contract',
    containerClassNames: ['col-md-6'],
  } as FieldLabelConfig,
];
